import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BellRing, Save } from "lucide-react";
import { toast } from "sonner";
import { inputCls } from "./shared";

const NotificationSettings = () => {
  const [email, setEmail] = useState("");
  const [original, setOriginal] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings/notifications")
      .then((r) => { setEmail(r.data.admin_notification_email || ""); setOriginal(r.data.admin_notification_email || ""); })
      .catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings/notifications", { admin_notification_email: email.trim() });
      setEmail(data.admin_notification_email); setOriginal(data.admin_notification_email);
      toast.success("Notification recipient saved");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-[var(--ir-border)] rounded-lg soft-shadow p-8 max-w-3xl mb-6" data-testid="notification-settings-card">
      <h3 className="font-display text-2xl text-[var(--ir-text)] flex items-center gap-2"><BellRing className="w-5 h-5 text-[var(--ir-orange)]" />Admin notification recipient</h3>
      <p className="text-[var(--ir-muted)] text-sm mt-3">
        Where admin alerts are delivered: <strong>new support ticket</strong>, <strong>affiliate reply on a ticket</strong>, <strong>new member application</strong>, and <strong>new affiliate</strong>.
        This is the recipient only — it does not change the sending address or the emails members and affiliates receive.
      </p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3 sm:items-end">
        <div className="flex-1">
          <Label className="text-[var(--ir-text)]">Notification email</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="imagereservations@gmail.com" className={`mt-2 ${inputCls}`} data-testid="notification-email-input" />
        </div>
        <Button onClick={save} disabled={saving || !email.trim() || email.trim() === original} className="bg-[var(--ir-orange)] hover:bg-[var(--ir-orange-soft)] text-white font-semibold rounded-none disabled:opacity-50" data-testid="save-notification-email-btn">
          <Save className="w-4 h-4 mr-2" />{saving ? "Saving…" : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default NotificationSettings;
